import { Tabs } from '@hotjar/hotsauce';
import { useTranslation } from '@hotjar/translations';

interface Tab {
  value: string;
  label: string;
}

type Tabs = Readonly<Tab[]>;

export type TabValue<T extends Tabs> = T[number]['value'];

export interface TabsNavProps<T extends Tabs> {
  onTabClick: (value: TabValue<T>) => void;
  selectedValue: TabValue<T>;
  tabs: T;
}

export function TabsNav<T extends Tabs>({
  onTabClick,
  selectedValue,
  tabs,
}: TabsNavProps<T>): JSX.Element {
  const { t } = useTranslation('feedback');
  return (
    <Tabs.Nav>
      {tabs.map(({ value, label }) => (
        <Tabs.Tab
          key={label}
          isSelected={value === selectedValue}
          onClick={() => onTabClick(value)}
        >
          {t(label)}
        </Tabs.Tab>
      ))}
    </Tabs.Nav>
  );
}
